import { faEraser } from '@fortawesome/free-solid-svg-icons';
import { ButtonHTMLAttributes } from 'react';
import { useStyles } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

interface IProps extends React.DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  buttonText?: string;
}

export const ClearFilterButton = ({ className, ...props }: IProps) => {
  const styles = useStyles();
  const classes = [styles.clearFitlerPurchaseButton, className].join(' ');
  return (
    <>
      <button {...props} className={classes}>
        <FontAwesomeIcon icon={faEraser} className={styles.iconClearPurchase} />
        {props.buttonText ?? null}
      </button>
    </>
  );
};
